import * as React from "react";
import { singleton } from "logic/singleton";
const RightSidebarContext = React.createContext(void 0);
export default singleton("contexts.RightSidebar", () => RightSidebarContext);
